/* libs */

import React, { Component } from "react";
import PropTypes from "prop-types";
import { asField } from "informed";

class MultiSelect extends Component {
	toggleItem = id => {
		const { fieldApi, fieldState } = this.props;
		const { setValue, setError } = fieldApi;
		const { value } = fieldState;
		const idPosition = value && value.indexOf(id);
		if (idPosition < 0) {
			setError("");
			setValue([...value, id]);
		} else if (idPosition > -1) {
			setValue([...value.slice(0, idPosition), ...value.slice(idPosition + 1)]);
		} else {
			setError("");
			setValue([id]);
		}
	};

	renderOptions = () => {
		const { fieldState, items } = this.props;
		const { value } = fieldState;
		return items.map((option, index) => {
			const { id, name } = option;
			const isSelected = value && value.indexOf(id) > -1 ? "option selected" : "option";
			return (
				<div onClick={() => this.toggleItem(id)} key={index} className={isSelected}>
					<p className="text">{name}</p>
				</div>
			);
		});
	};

	onBlur = () => {
		const { fieldApi, fieldState, errorMessage } = this.props;
		const { value } = fieldState;
		const { setError } = fieldApi;
		const message = errorMessage ? errorMessage : "please select at lease one";
		if (!value || value.length === 0) {
			setError(message);
		} else {
			setError("");
		}
	};

	render() {
		const { label, fieldState, isRequired } = this.props;
		const { error } = fieldState;
		return (
			<div onBlur={this.onBlur} className={`multiselect ${error ? "error" : ""}`}>
				{error ? (
					<p className="error">{error}</p>
				) : (
					<p className="prompt">
						{isRequired && <span className="isrequired-label">*</span>}
						{label}
					</p>
				)}
				<div tabIndex="-1" className="multiselect-list">
					{this.renderOptions()}
				</div>
			</div>
		);
	}
}

MultiSelect.propTypes = {
	fieldApi: PropTypes.object,
	fieldState: PropTypes.object,
	field: PropTypes.string,
	id: PropTypes.string,
	items: PropTypes.array,
	label: PropTypes.string,
	errorMessage: PropTypes.string,
	isRequired: PropTypes.bool,
};

const Wrapper = asField(({ fieldState, ...props }) => <MultiSelect fieldState={fieldState} {...props} />);

export default Wrapper;
